var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _path9, _path10, _path11, _g2, _g3, _path12, _path13, _path14, _path15, _g4, _ellipse, _ellipse2, _ellipse3, _rect, _path16, _path17, _g5, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThird(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.37744 44.919C8.81867 43.5801 11.6869 42.0222 13.2803 41.4287L15.7692 45.8307L22.4218 47.2981C21.5932 47.2981 14.5387 50.5818 11.4846 52.1892V47.2475C9.967 46.1568 8.37744 44.919 8.37744 44.919Z",
    fill: "#FFA02E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8145 44.919C46.3732 43.5801 43.505 42.0222 41.9116 41.4287L39.4227 45.8307L32.2773 47.2981C33.1059 47.2981 40.6532 50.5818 43.7072 52.1892V47.2475C45.2249 46.1568 46.8145 44.919 46.8145 44.919Z",
    fill: "#FFA02E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4649 43.874L22.4216 47.2978L15.769 45.8305L19.4649 43.874Z",
    fill: "#DE7123"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4806 43.874L32.2775 47.2978L39.4229 45.8305L35.4806 43.874Z",
    fill: "#DE7123"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.39 0.83252L35.2851 10.0034H19.4948L27.39 0.83252Z",
    fill: "url(#paint0_linear_1565_28664)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3903 53.1677L19.4952 43.9969L35.2855 43.9969L27.3903 53.1677Z",
    fill: "url(#paint1_linear_1565_28664)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1565_28664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.1729 3.18042L28.0876 5.94089L30.8688 6.84876L28.0876 7.75663L27.1729 10.5171L26.2583 7.75663L23.4771 6.84876L26.2583 5.94089L27.1729 3.18042Z",
    fill: "white",
    fillOpacity: 0.62
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1729 3.26335L28.0629 5.9491L28.067 5.9616L28.0795 5.96569L30.7848 6.84876L28.0795 7.73183L28.067 7.73592L28.0629 7.74842L27.1729 10.4342L26.283 7.74842L26.2789 7.73592L26.2664 7.73183L23.5611 6.84876L26.2664 5.96569L26.2789 5.9616L26.283 5.9491L27.1729 3.26335Z",
    stroke: "#FFC886",
    strokeWidth: 0.0521719
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.222 40.0841L38.2726 42.2851L46.1677 28.7122L50.222 40.0841Z",
    fill: "url(#paint2_linear_1565_28664)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55827 13.9162L16.5077 11.7152L8.61253 25.288L4.55827 13.9162Z",
    fill: "url(#paint3_linear_1565_28664)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2218 13.9164L46.1676 25.2882L38.2724 11.7154L50.2218 13.9164Z",
    fill: "url(#paint4_linear_1565_28664)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55843 40.0836L8.6127 28.7118L16.5078 42.2846L4.55843 40.0836Z",
    fill: "url(#paint5_linear_1565_28664)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7101 26.7552C47.7101 37.7576 38.7237 46.6784 27.6363 46.6784C16.549 46.6784 7.56256 37.7576 7.56256 26.7552C7.56256 15.7529 16.549 6.83209 27.6363 6.83209C38.7237 6.83209 47.7101 15.7529 47.7101 26.7552Z",
    fill: "url(#paint6_linear_1565_28664)",
    stroke: "url(#paint7_linear_1565_28664)",
    strokeWidth: 0.26086
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_1565_28664)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.6363,
    cy: 26.7557,
    rx: 17.7403,
    ry: 17.608,
    fill: "url(#paint8_linear_1565_28664)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_ii_1565_28664)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.6366,
    cy: 26.7556,
    rx: 14.7836,
    ry: 14.6734,
    fill: "url(#paint9_linear_1565_28664)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1565_28664)"
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9066 24.2489C18.6435 23.5423 19.4336 22.909 20.066 23.3194L31.8957 30.9966C32.5494 31.4208 32.249 32.4356 31.4697 32.4356H22.4977C22.1708 32.4356 21.8784 32.2324 21.7643 31.9261L18.9066 24.2489Z",
    fill: "url(#paint10_linear_1565_28664)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3643 24.2394C36.63 23.5346 35.8441 22.898 35.2098 23.3044L23.2088 30.9941C22.5507 31.4158 22.8494 32.4356 23.631 32.4356H32.7329C33.0586 32.4356 33.3502 32.2339 33.4651 31.9291L36.3643 24.2394Z",
    fill: "url(#paint11_linear_1565_28664)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9356 21.4273C27.2218 20.8425 28.0552 20.8425 28.3414 21.4273L33.2281 31.411C33.4826 31.931 33.1041 32.5377 32.5252 32.5377H22.7517C22.1729 32.5377 21.7944 31.931 22.0488 31.411L26.9356 21.4273Z",
    fill: "url(#paint12_linear_1565_28664)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1565_28664",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 20,
    width: 13,
    height: 13
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9356 21.4273C27.2218 20.8425 28.0552 20.8425 28.3414 21.4273L33.2281 31.411C33.4826 31.931 33.1041 32.5377 32.5252 32.5377H22.7517C22.1729 32.5377 21.7944 31.931 22.0488 31.411L26.9356 21.4273Z",
    fill: "url(#paint13_linear_1565_28664)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1565_28664)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_1565_28664)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 6.43198,
    cy: 1.74555,
    rx: 6.43198,
    ry: 1.74555,
    transform: "matrix(0.204188 0.978932 -0.979534 0.201279 31.6216 21.5654)",
    fill: "#ECA26C"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.6388,
    cy: 19.0732,
    rx: 1.13047,
    ry: 1.12204,
    fill: "url(#paint14_linear_1565_28664)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.7057,
    cy: 22.3372,
    rx: 0.924928,
    ry: 0.918033,
    fill: "url(#paint15_linear_1565_28664)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.5245,
    cy: 22.3372,
    rx: 0.924928,
    ry: 0.918033,
    fill: "url(#paint16_linear_1565_28664)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.9082,
    y: 33.4229,
    width: 11.2436,
    height: 1.52178,
    rx: 0.760892,
    fill: "url(#paint17_linear_1565_28664)"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7518 14.0386L20.1177 15.1428L21.2302 15.5059L20.1177 15.8691L19.7518 16.9732L19.3859 15.8691L18.2734 15.5059L19.3859 15.1428L19.7518 14.0386Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3167 9.14771L16.1704 11.7241L18.7662 12.5715L16.1704 13.4188L15.3167 15.9953L14.463 13.4188L11.8672 12.5715L14.463 11.7241L15.3167 9.14771Z",
    fill: "white"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1565_28664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.8267 39.584L15.7689 45.8309C26.3638 40.2061 36.4659 44.3636 39.4227 45.8309L43.3649 39.584C42.2376 38.2916 37.5134 35.6779 27.6351 35.5631C17.7568 35.4482 12.9802 38.1958 11.8267 39.584Z",
    fill: "url(#paint18_linear_1565_28664)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1565_28664)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.5241 40.5706L22.8492 37.9501V37.9279H21.3166V37.5351H23.3235V37.9412L22.0029 40.5706H21.5241ZM24.0227 40.5706L25.3477 37.9501V37.9279H23.8152V37.5351H25.822V37.9412L24.5014 40.5706H24.0227ZM28.0345 38.3325C28.0187 38.1922 27.9535 38.0835 27.8389 38.0064C27.7242 37.9284 27.58 37.8893 27.4061 37.8893C27.2816 37.8893 27.1739 37.9091 27.083 37.9486C26.9921 37.9872 26.9214 38.0405 26.871 38.1087C26.8216 38.1759 26.7969 38.2525 26.7969 38.3384C26.7969 38.4106 26.8137 38.4728 26.8473 38.5252C26.8819 38.5775 26.9268 38.6215 26.9822 38.6571C27.0385 38.6917 27.0988 38.7208 27.163 38.7445C27.2272 38.7673 27.289 38.786 27.3483 38.8009L27.6447 38.8779C27.7415 38.9016 27.8408 38.9338 27.9426 38.9743C28.0444 39.0148 28.1388 39.0681 28.2257 39.1343C28.3127 39.2005 28.3828 39.2826 28.4362 39.3804C28.4905 39.4782 28.5177 39.5953 28.5177 39.7317C28.5177 39.9036 28.4732 40.0562 28.3843 40.1896C28.2964 40.323 28.1684 40.4283 28.0004 40.5053C27.8334 40.5824 27.6314 40.6209 27.3942 40.6209C27.167 40.6209 26.9703 40.5849 26.8043 40.5128C26.6383 40.4406 26.5084 40.3384 26.4145 40.2059C26.3206 40.0726 26.2688 39.9145 26.2589 39.7317H26.7184C26.7272 39.8413 26.7628 39.9327 26.8251 40.0059C26.8883 40.078 26.9688 40.1318 27.0667 40.1674C27.1655 40.202 27.2737 40.2193 27.3913 40.2193C27.5207 40.2193 27.6358 40.199 27.7366 40.1585C27.8384 40.117 27.9184 40.0597 27.9767 39.9866C28.035 39.9125 28.0642 39.826 28.0642 39.7272C28.0642 39.6373 28.0385 39.5637 27.9871 39.5064C27.9367 39.4491 27.868 39.4016 27.7811 39.3641C27.6951 39.3265 27.5978 39.2934 27.4891 39.2648L27.1304 39.167C26.8873 39.1008 26.6946 39.0034 26.5524 38.875C26.4111 38.7465 26.3404 38.5766 26.3404 38.3651C26.3404 38.1902 26.3878 38.0376 26.4827 37.9071C26.5776 37.7767 26.706 37.6754 26.8681 37.6033C27.0301 37.5302 27.2129 37.4936 27.4165 37.4936C27.622 37.4936 27.8033 37.5297 27.9604 37.6018C28.1185 37.6739 28.243 37.7732 28.3339 37.8997C28.4248 38.0252 28.4722 38.1695 28.4762 38.3325H28.0345ZM31.7017 39.0528C31.7017 39.3769 31.6425 39.6556 31.5239 39.8888C31.4053 40.121 31.2428 40.2998 31.0362 40.4253C30.8307 40.5498 30.597 40.6121 30.3352 40.6121C30.0724 40.6121 29.8377 40.5498 29.6312 40.4253C29.4256 40.2998 29.2636 40.1205 29.145 39.8873C29.0264 39.6541 28.9672 39.3759 28.9672 39.0528C28.9672 38.7287 29.0264 38.4506 29.145 38.2184C29.2636 37.9852 29.4256 37.8063 29.6312 37.6818C29.8377 37.5563 30.0724 37.4936 30.3352 37.4936C30.597 37.4936 30.8307 37.5563 31.0362 37.6818C31.2428 37.8063 31.4053 37.9852 31.5239 38.2184C31.6425 38.4506 31.7017 38.7287 31.7017 39.0528ZM31.2482 39.0528C31.2482 38.8058 31.2082 38.5978 31.1281 38.4288C31.0491 38.2589 30.9404 38.1304 30.8021 38.0435C30.6647 37.9555 30.5091 37.9116 30.3352 37.9116C30.1603 37.9116 30.0042 37.9555 29.8668 38.0435C29.7295 38.1304 29.6208 38.2589 29.5408 38.4288C29.4617 38.5978 29.4222 38.8058 29.4222 39.0528C29.4222 39.2999 29.4617 39.5083 29.5408 39.6783C29.6208 39.8473 29.7295 39.9757 29.8668 40.0637C30.0042 40.1506 30.1603 40.1941 30.3352 40.1941C30.5091 40.1941 30.6647 40.1506 30.8021 40.0637C30.9404 39.9757 31.0491 39.8473 31.1281 39.6783C31.2082 39.5083 31.2482 39.2999 31.2482 39.0528ZM32.2727 40.5706V37.5351H32.7307V40.1763H34.1062V40.5706H32.2727Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1565_28664",
    x: 22.1728,
    y: 1.87612,
    width: 10.0002,
    height: 9.94527,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.652149,
    result: "effect1_foregroundBlur_1565_28664"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_1565_28664",
    x: 9.896,
    y: 8.62599,
    width: 35.4805,
    height: 35.7378,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.521719
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.521719
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.172667 0 0 0 0 0.616667 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1565_28664"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_1565_28664",
    x: 12.853,
    y: 11.5606,
    width: 29.5669,
    height: 30.3901,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.521719
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3043
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.4875 0 0 0 0 0.1755 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1565_28664"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.521719
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.3043
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.716167 0 0 0 0 0.454167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_1565_28664",
    result: "effect2_innerShadow_1565_28664"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1565_28664",
    x: 16.7373,
    y: 17.4295,
    width: 21.7558,
    height: 19.0803,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.521719
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.521719
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.6 0 0 0 0 0.361709 0 0 0 0 0.19 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1565_28664"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1565_28664",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_1565_28664",
    x: 27.5037,
    y: 20.3416,
    width: 7.44282,
    height: 15.7434,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.782579,
    result: "effect1_foregroundBlur_1565_28664"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1565_28664",
    x: 6.60947,
    y: 32.951,
    width: 41.9725,
    height: 20.7056,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.6086
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.6086
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1565_28664"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1565_28664",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1565_28664",
    x: 21.3164,
    y: 37.4937,
    width: 12.7896,
    height: 3.38806,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.26086
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.221676 0 0 0 0 0.154219 0 0 0 0 0.5875 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1565_28664"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1565_28664",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1565_28664",
    x1: 24.108,
    y1: 4.50086,
    x2: 30.6719,
    y2: 4.50086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488759,
    stopColor: "#FFC786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#D1E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488959,
    stopColor: "#D18E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1565_28664",
    x1: 30.6723,
    y1: 49.4994,
    x2: 24.1084,
    y2: 49.4994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488759,
    stopColor: "#FFC786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#D1E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488959,
    stopColor: "#D18E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1565_28664",
    x1: 48.6622,
    y1: 35.4289,
    x2: 45.417,
    y2: 41.092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488759,
    stopColor: "#FFC786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#D1E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488959,
    stopColor: "#D18E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1565_28664",
    x1: 6.11803,
    y1: 18.5714,
    x2: 9.36328,
    y2: 12.9082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488759,
    stopColor: "#FFC786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#D1E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488959,
    stopColor: "#D18E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1565_28664",
    x1: 45.3801,
    y1: 12.9295,
    x2: 48.6254,
    y2: 18.5926,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488759,
    stopColor: "#FFC786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#D1E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488959,
    stopColor: "#D18E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1565_28664",
    x1: 9.40015,
    y1: 41.0705,
    x2: 6.15489,
    y2: 35.4074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.488759,
    stopColor: "#FFC786"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488859,
    stopColor: "#D1E5EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.488959,
    stopColor: "#D18E5C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1565_28664",
    x1: 14.6849,
    y1: 11.8436,
    x2: 41.4005,
    y2: 41.8656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC887"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520833,
    stopColor: "#FFE7CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B45612"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1565_28664",
    x1: 27.6363,
    y1: 6.70166,
    x2: 27.6363,
    y2: 46.8088,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1565_28664",
    x1: 16.3022,
    y1: 13.3052,
    x2: 38.7695,
    y2: 40.6161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D28E5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC887"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1565_28664",
    x1: 17.8534,
    y1: 14.6717,
    x2: 29.8775,
    y2: 41.4965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD92"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.484375,
    stopColor: "#D88335"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9C5A2A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1565_28664",
    x1: 19.0534,
    y1: 24.9893,
    x2: 25.0224,
    y2: 29.3631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDBB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D4905F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1565_28664",
    x1: 35.5998,
    y1: 23.7261,
    x2: 32.0047,
    y2: 30.2458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDBAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D28E5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1565_28664",
    x1: 24.4968,
    y1: 26.4497,
    x2: 30.8699,
    y2: 26.4497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.49728,
    stopColor: "#FFC886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49738,
    stopColor: "#D28E5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1565_28664",
    x1: 24.4968,
    y1: 26.4497,
    x2: 30.8699,
    y2: 26.4497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.416667,
    stopColor: "#B1B0D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49738,
    stopColor: "#FFCC1D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1565_28664",
    x1: 27.6388,
    y1: 17.9512,
    x2: 27.6388,
    y2: 20.1953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D28E5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1565_28664",
    x1: 18.7057,
    y1: 21.4192,
    x2: 18.7057,
    y2: 23.2553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D28E5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1565_28664",
    x1: 36.5245,
    y1: 21.4192,
    x2: 36.5245,
    y2: 23.2553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE5C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D28E5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1565_28664",
    x1: 22.036,
    y1: 34.1837,
    x2: 33.2795,
    y2: 34.1837,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC886"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D28E5D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1565_28664",
    x1: 13.5141,
    y1: 41.4977,
    x2: 41.9097,
    y2: 41.1812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA02E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C85A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThird);
export default __webpack_public_path__ + "static/media/third.07442771f61bb785707e31018b65c433.svg";
export { ForwardRef as ReactComponent };